import React, { createContext, useContext, useReducer } from "react";
import InvoicesReducer from "../reducers/InvoicesReducer";
import InvoicesService from "../services/InvoicesService";
import { SET_TOTAL, HIDE_SPINNER, SHOW_SPINNER } from "../types";
import {
  SET_INVOICE,
  CLEAR_INVOICES,
  CREATE_INVOICE,
  INVOICES_RECEIVED,
  SET_PROPERTY_INVOICE,
} from "../types/invoices";
import { ModalContext } from "./ModalContext";

const initialState = {
  invoices: null,
  spinner: false,
};

export const InvoicesContext = createContext(initialState);

export const InvoicesProvider = ({ children }) => {
  const [state, dispatch] = useReducer(InvoicesReducer, initialState);

  const { alert, success } = useContext(ModalContext);

  const handleError = (error, message) => {
    dispatch({ type: HIDE_SPINNER });
    if (error.response) {
      if (error.response.data) {
        return alert(error.response.data.message);
      }
    }
    if (message && message !== "" && message !== null) {
      return alert(message);
    }
    alert(error);
  };

  const getInvoices = (filters) => {
    dispatch({ type: SHOW_SPINNER });
    dispatch({ type: CLEAR_INVOICES });
    InvoicesService.getInvoicesAdmin(filters)
      .then((res) => {
        const { total, invoices } = res.data;
        dispatch({ type: HIDE_SPINNER });
        dispatch({ type: SET_TOTAL, payload: total });
        dispatch({ type: INVOICES_RECEIVED, payload: invoices });
      })
      .catch((error) => {
        alert(error);
        dispatch({ type: HIDE_SPINNER });
      });
  };

  const createInvoice = () => {
    dispatch({ type: CREATE_INVOICE });
  };

  const setInvoice = (purchase) => {
    dispatch({ type: SET_INVOICE, payload: purchase });
  };

  const setPropertyInvoice = (key, value) => {
    dispatch({ type: SET_PROPERTY_INVOICE, payload: { key, value } });
  };

  const saveInvoice = (purchase, callback) => {
    let service = InvoicesService.putInvoice;
    if (isNaN(parseInt(purchase.purchase_id))) {
      service = InvoicesService.postInvoice;
    }
    dispatch({ type: SHOW_SPINNER });
    service(purchase)
      .then(() => {
        success("Cargo guardado.");
        dispatch({ type: HIDE_SPINNER });
        if (typeof callback === "function") callback();
      })
      .catch(handleError);
  };

  return (
    <InvoicesContext.Provider
      value={{
        ...state,
        setInvoice,
        getInvoices,
        saveInvoice,
        createInvoice,
        setPropertyInvoice,
      }}
    >
      {children}
    </InvoicesContext.Provider>
  );
};
